import React from 'react';
import ExpiryPicker from './ExpiryPicker.tsx';
import LocationSelector from './LocationSelector.tsx';
import ParentProductSelector from './ParentProductSelector.tsx';
import { Product } from '../../utils/grocyApi.ts';
import { ExpiryExtractionResult } from '../../utils/aiExpiryDate.ts';

interface PurchaseFormFieldsProps {
  // Common form fields
  expiryDate: string;
  onExpiryDateChange: (date: string) => void;
  onRequestPhotoCapture?: () => Promise<ExpiryExtractionResult | null>;
  locationId: number | null;
  onLocationIdChange: (id: number | null) => void;
  
  // Parent product selection (optional - not all flows need this)
  showParentSelector?: boolean;
  parentProductId?: number | null;
  onParentProductSelect?: (product: Product) => void;
  onParentProductClear?: () => void;
  parentProductSearchTerm?: string;
  onParentProductSearchTermChange?: (term: string) => void;
  products?: Product[];
}

const PurchaseFormFields: React.FC<PurchaseFormFieldsProps> = ({
  expiryDate,
  onExpiryDateChange,
  onRequestPhotoCapture,
  locationId,
  onLocationIdChange,
  showParentSelector = false,
  parentProductId,
  onParentProductSelect,
  onParentProductClear,
  parentProductSearchTerm,
  onParentProductSearchTermChange,
  products,
}) => {
  return (
    <>
      {/* Expiry Date Picker */}
      <div className="purchase-controls__field purchase-controls__field--vertical">
        <label>Expiry Date:</label>
        <ExpiryPicker value={expiryDate} onChange={onExpiryDateChange} onRequestPhotoCapture={onRequestPhotoCapture} />
      </div>

      {/* Location Selector */}
      <div className="purchase-controls__field">
        <label>Location:</label>
        <LocationSelector 
          value={locationId} 
          onChange={onLocationIdChange} 
        />
      </div>

      {/* Parent Product Selector */}
      {showParentSelector && onParentProductSelect && onParentProductClear && (
        <div className="purchase-controls__field">
          <label>Parent Product:</label>
          <ParentProductSelector
            parentProductId={parentProductId || null}
            onSelect={onParentProductSelect}
            onClear={onParentProductClear}
            searchTerm={parentProductSearchTerm || ''}
            onSearchTermChange={onParentProductSearchTermChange || (() => {})}
            products={products}
          />
        </div>
      )}
    </>
  );
};

export default PurchaseFormFields;
